module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_16.81998dad.jpeg";